/**
 * Syncs Advanced Commerce product cards with theme product.json:
 * - low-stock badges
 * - Set of 2 unit label (tag or custom.is_set_of_2 pair SKUs)
 * - strip trailing "- Set of 2" from titles
 */
(function () {
  const productCache = new Map();
  let debounceTimer;

  const CARD_SELECTORS = [
    '.acs_auto_prod',
    '.product-card-wrapper',
    '.grid__item .card-wrapper',
    '#product-grid .grid__item',
  ].join(',');

  const OBSERVE_SELECTORS = [
    '.acs_auto_popup',
    '.acs_collection_results',
    '.acs_results',
    '#product-grid',
  ];

  const getHandleFromCard = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const fetchProductFlags = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);

    const promise = (async () => {
      try {
        const response = await fetch(`/products/${handle}?view=json`, { method: 'GET' });
        if (!response.ok) return { low_stock: false, is_set_of_2: false };
        const data = await response.json();
        return {
          low_stock: data?.low_stock === true,
          is_set_of_2: data?.is_set_of_2 === true || data?.is_set_of_2_pair === true,
        };
      } catch (_) {
        return { low_stock: false, is_set_of_2: false };
      }
    })();

    productCache.set(handle, promise);
    return promise;
  };

  const getBadgeHost = (card) =>
    card.querySelector('.card__badge') ||
    card.querySelector('.acs_auto_prod_image') ||
    card.querySelector('.card__media') ||
    card;

  const applyLowStockBadge = (card, message) => {
    if (card.querySelector('.prd-Card_Urgency')) return;
    const host = getBadgeHost(card);
    if (!host) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'prd-Card_Messaging js-LowStockMessaging';
    wrapper.innerHTML = `<div class="prd-Card_Urgency">${message}</div>`;
    host.appendChild(wrapper);
  };

  /**
   * GrapheneHC often labels dining chairs "each" unless the Set of 2 tag is indexed.
   * Pair metafield SKUs need the same "Set of 2" unit label as legacy tagged products.
   */
  const applySetOf2UnitLabel = (card) => {
    const priceRoot =
      card.querySelector('.acs_auto_prod_price') ||
      card.querySelector('.price') ||
      card.querySelector('.card-information') ||
      card;

    let unitEl = priceRoot.querySelector('.prd-Price_each_item');
    if (!unitEl) {
      unitEl = document.createElement('span');
      unitEl.className = 'prd-Price_each_item';
      unitEl.innerHTML = '<span>Set of 2</span>';
      priceRoot.appendChild(unitEl);
      return;
    }

    unitEl.classList.remove('each');
    const label = (unitEl.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^set of 2$/i.test(label)) {
      unitEl.innerHTML = '<span>Set of 2</span>';
    }
  };

  const processCard = async (card) => {
    const handle = getHandleFromCard(card);
    if (!handle) return;

    const flags = await fetchProductFlags(handle);
    const message = window.theme?.urgency_message;

    if (flags.low_stock && message) {
      applyLowStockBadge(card, message);
    }

    if (flags.is_set_of_2) {
      applySetOf2UnitLabel(card);
    }
  };

  const processAll = (root = document) => {
    if (typeof window.stripSetOf2TitlesInRoot === 'function') {
      window.stripSetOf2TitlesInRoot(root);
    }
    for (const card of root.querySelectorAll(CARD_SELECTORS)) {
      processCard(card);
    }
  };

  const scheduleProcess = (root) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => processAll(root || document), 50);
  };

  window.applyLowStockProductCards = (root) => scheduleProcess(root);

  document.addEventListener('swym:collections-loaded', () => scheduleProcess(document));
  document.addEventListener('DOMContentLoaded', () => {
    for (const selector of OBSERVE_SELECTORS) {
      const target = document.querySelector(selector);
      if (target) {
        new MutationObserver(() => scheduleProcess(target)).observe(target, {
          childList: true,
          subtree: true,
        });
      }
    }
    scheduleProcess(document);
  });

  if (document.readyState !== 'loading') scheduleProcess(document);
})();
